import langDe from 'quasar/lang/de.js'

import iconSet from 'quasar/icon-set/material-icons.js'
import '@quasar/extras/material-icons/material-icons.css'

import { Loading } from 'quasar';

//import iconSet from 'quasar/icon-set/mdi-v7.js'
//import '@quasar/extras/mdi-v7/mdi-v7.css'

// Import Quasar css
import './quasar.scss';//instead of 'quasar/src/css/index.sass'
import { QDate, QBtn, QInput, QSelect, QSeparator, QField } from 'quasar';

//override defaults
QInput.props.outlined = { default: true }
QInput.props.hideBottomSpace = { default: true }
QSelect.props.outlined = { default: true }
QSelect.props.hideBottomSpace = { default: true }

QField.props.hideBottomSpace = { default: true }
QField.props.stackLabel = { default: true }
QField.props.borderless = { default: true }
QField.props.color = { default: 'dark' }

QDate.props.flat = { default: true }
QDate.props.bordered = { default: true }
QDate.props.outlined = { default: true }
QDate.props.mask = { default: 'YYYY-MM-DD' }//default
QSeparator.props.size = { default: '3px' }


export default {
  components: { QDate, QBtn, QInput, QSelect, QSeparator, QField },
  lang: langDe,
  plugins: { Loading },
  loading: { spinnerSize: 30 /* look at QuasarConfOptions from the API card */ },
  iconSet: iconSet,
}